// extracted by mini-css-extract-plugin
export default {"countdownContainer":"_1o3rcUDkHbQrOD2xmxNM8g"};